(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AMI", [], factory);
	else if(typeof exports === 'object')
		exports["AMI"] = factory();
	else
		root["AMI"] = factory();
})(window, function() {
return 